import { render, staticRenderFns } from "./satsList.vue?vue&type=template&id=f068586e&scoped=true&"
import script from "./satsList.vue?vue&type=script&lang=js&"
export * from "./satsList.vue?vue&type=script&lang=js&"
import style0 from "./satsList.vue?vue&type=style&index=0&id=f068586e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f068586e",
  null
  
)

export default component.exports